import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../../services/auth/auth';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

export const unauthGuard: CanActivateFn = () => {
  const authService = inject(Auth);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  router.navigate([ROUTE_PATHS.FUND_MANAGEMENT]);
  return false;
};
